import moment from "moment-timezone"

moment.tz.setDefault(moment.tz.guess())

export const pastEvent = (eventStart, eventEnd, currentTime) => {
  return (
    eventEnd.isSameOrBefore(currentTime) && eventStart.isBefore(currentTime)
  )
}

export const futureEvent = (eventStart, eventEnd, currentTime, duration) => {
  return (
    eventEnd.isAfter(currentTime.clone().add(duration, "minutes")) &&
    eventStart.isSameOrAfter(currentTime.clone().add(duration, "minutes"))
  )
}
